import styled from 'styled-components';
import StyledDatepicker from 'StyledDatepicker.js';
import {rem} from 'polished';

const FontFamily = ({theme: {$fontFamily}}) => `${$fontFamily}`;
const FwRegular = ({theme:{$fwRegular}}) => `${$fwRegular}`;
const FwSemibold = ({theme:{$fwSemibold}}) => `${$fwSemibold}`;

const baseFont = '16px';
const S = {};

S.AccountSessionHistory = styled.div`
  box-sizing: border-box;
  width: 100%;
  font-family: ${FontFamily};
`;

S.AccountSessionHistoryTop = styled.div`
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  background: ${({theme:{$accountSessionHistoryTopBgColor}})=> $accountSessionHistoryTopBgColor};
`;

S.CurrentSessionTimer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${rem('12px', baseFont)} 0;
  & .session-timer {
    & span {
      margin-right: 0.3rem;
      display: flex;
      align-items: baseline;
      font-size:  ${rem('24px', baseFont)};
      font-weight: ${FwSemibold};
      color: ${({theme:{$accountSessionHistoryTimerNumbersColor}})=> $accountSessionHistoryTimerNumbersColor};
      & span {
        font-size:  ${rem('16px', baseFont)};
        color: #000;
      }
    }
  }
`;

S.CurrentSessionTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

S.CurrentSessionIcon = styled.i`
  margin-right: ${rem('20px', baseFont)};
  width: ${rem('30px', baseFont)};
  height: ${rem('30px', baseFont)};
  & > svg{
    width: 100%;
    & path:nth-of-type(2){
      fill: #000 !important;
    }
  }

`;

S.CurrentSessionLabel = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-weight: ${FwSemibold};
  font-size:  ${rem('14px', baseFont)};
  margin-right: ${rem('32px', baseFont)};
  
`;

S.AccountSessionHistoryFiltersDates = styled.div`
    display: flex;
    margin-right: ${rem('5px', baseFont)};
    margin-bottom:  ${rem('10px', baseFont)};
    & > div{
        &:last-of-type{
            margin-right: 0;
        }
    }
`;

S.AccountSessionHistoryListWrapper = styled.div`
  padding: 0 16px;
`;

S.AccountSessionHistoryList = styled.div``;

S.AccountSessionHistoryListItem = styled.div``;

S.NoResult  = styled.div`
     height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

S.DateIcon = styled.i`
  position: absolute;
    right: ${rem('12px', baseFont)};
    height: ${rem('16px', baseFont)};
    width: ${rem('16px', baseFont)};
    top: 0;
    bottom: 0;
    margin: auto 0;
    pointer-events: none;
    & svg{
      width: 100%;
    }
`;

S.DateWrapper = styled.div`
    width: ${rem('297px', baseFont)};
    height: ${rem('42px', baseFont)};
    display: flex;
    background-color: #fff;
    position: relative;
    border: 1px solid rgba(0, 0, 0, 0.24);
    margin-right: ${rem('5px', baseFont)};
    border-radius: 3px;
    padding: 0 ${rem('13px', baseFont)};
    
    & .react-datepicker-wrapper,
    & .react-datepicker__input-container{
    width: 100%;
    display: flex;
    }
    & .react-datepicker__input-container{
    padding: 0;
    }

    ${StyledDatepicker.Datepicker}{
        background-color: transparent;
        flex: 1;
        padding-left: 0;
        font-size: ${rem('14px', baseFont)};
        font-weight: ${FwRegular};
        border-radius: 0;
        width: 100%;
        color: rgba(0, 0, 0, 0.54);
    }
`;

S.AccountSessionHistoryListItemsWrapper = styled.div``;

S.AccountSessionHistoryListItemsHeader = styled.div`
     line-height: 1;
     color: rgba(0, 0, 0, 0.87);
     font-size:  ${rem('12px', baseFont)};
     font-weight: ${FwSemibold};
     border-bottom: 2px solid #D32F2F;
     height:  ${rem('36px', baseFont)};
     margin-bottom:  ${rem('14px', baseFont)};
     display: flex;
     align-items: center;
`;

S.AccountSessionHistoryListItem = styled.div`
display: flex;
  height:  ${rem('64px', baseFont)};
  padding: 0  ${rem('15px', baseFont)};
  background-color: #fff;
  &.even{
    background-color: rgba(255, 255, 255, 0.6);
  }
`;

S.SessionOpen = styled.div`
  width: 33%;
  display: flex;
`;
S.SessionClose = styled(S.SessionOpen)``;
S.SessionTime = styled(S.SessionOpen)``;

S.SessionOpenIcon = styled.i`
  align-self: center;
  margin-right: ${rem('10px', baseFont)};
  width: ${rem('20px', baseFont)};
  height: ${rem('20px', baseFont)};
  & > svg{
    width: 100%;
    & path:nth-of-type(2){
      fill: #000 !important;
    }
  }
`;
S.SessionCloseIcon = styled(S.SessionOpenIcon)``;
S.SessionTimeIcon = styled(S.SessionOpenIcon)``;

S.SessionDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

S.SessionDetailsText = styled.div`
   color: rgba(0, 0, 0, 0.87);
   font-size:  ${rem('12px', baseFont)};
`;

S.SessionDetailsTime = styled.div`
   color: rgba(0, 0, 0, 0.87);
   font-size:  ${rem('12px', baseFont)};
   font-weight: ${FwSemibold};
`;

export default S;